// extracted by mini-css-extract-plugin
export var columnList = "_jm-0";